/*
  TimelessXI: quick add by size on product cards (snippets/card-product.liquid).
  Tapping a size adds that variant and opens the cart drawer, the same way the product page's Add to cart does
  (product-form.js). On touch screens the + button opens and closes the size panel.
*/
if (!customElements.get('txi-quick-sizes')) {
  customElements.define(
    'txi-quick-sizes',
    class TxiQuickSizes extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.txi-qs__toggle');
        this.status = this.querySelector('.txi-qs__status');

        this.toggle?.addEventListener('click', (event) => {
          event.preventDefault();
          this.setOpen(!this.classList.contains('is-open'));
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-variant-id]');
          if (!button) return;
          event.preventDefault();
          this.add(button);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.classList.contains('is-open')) return;
          this.setOpen(false);
          this.toggle.focus();
        });
      }

      setOpen(open) {
        this.classList.toggle('is-open', open);
        this.toggle?.setAttribute('aria-expanded', open);
        if (open) this.querySelector('[data-variant-id]')?.focus();
      }

      setStatus(message = '', isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }

      add(button) {
        if (button.getAttribute('aria-disabled') === 'true') return;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
        this.setStatus();

        const body = new FormData();
        body.append('id', button.dataset.variantId);
        body.append('quantity', '1');
        if (cart) {
          body.append('sections', cart.getSectionsToRender().map((section) => section.id));
          body.append('sections_url', window.location.pathname);
          cart.setActiveElement(button);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = body;

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.setStatus(response.description || response.message || this.dataset.error, true);
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'txi-quick-sizes',
              productVariantId: button.dataset.variantId,
              cartData: response,
            });
            this.setStatus(this.dataset.added);
            setTimeout(() => this.setStatus(), 3000);
            this.setOpen(false);
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch(() => this.setStatus(this.dataset.error, true))
          .finally(() => {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
